import { ComponentMeta, ComponentStory } from "@storybook/react";
import { AlignJustify } from "lucide-react";
import React from "react";
import { MemoryRouter } from "react-router-dom";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import TopBar from "../TopBar/TopBar";

const commonArgs: React.ComponentProps<typeof TopBar> = {
    sidebarButton: <AlignJustify />
};

export default {
    title: "Layout/TopBar",
    component: TopBar,
    args: commonArgs
} as ComponentMeta<typeof TopBar>;

const Template: ComponentStory<typeof TopBar> = ({ ...args }) => {
    return (
        <MemoryRouter initialEntries={["/"]}>
            <TopBar {...args} />
        </MemoryRouter>
    );
};

export const Default = Template.bind({});

export const WithDoubleBar = Template.bind({});
WithDoubleBar.args = {
    title: "Title"
};

export const WithBackLink = Template.bind({});
WithBackLink.args = {
    backlink: {
        title: "Back to all",
        url: "/",
        trackName: "trackName"
    }
};

export const WithTabs = Template.bind({});
WithTabs.args = {
    tabs: [
        {
            title: "Tab A",
            path: "/"
        },
        {
            title: "Tab B",
            path: "/b",
            matchExact: true
        },
        {
            title: "Tab C",
            path: "/b/c"
        }
    ]
};

export const WithBreadcrumbs = Template.bind({});
WithBreadcrumbs.args = {
    breadcrumbs: (
        <Breadcrumbs
            breadcrumbs={[
                {
                    title: "Page A",
                    to: "/page"
                },
                {
                    title: "Page B",
                    isBeta: true
                }
            ]}
        />
    )
};
